import React, { useState, useEffect } from "react";
import { Provider } from 'react-redux';
import { store } from './redux/store'; // use named import syntax
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import "./style.css";
import Settings from './components/settings';
import { ChartStyle } from './components/chart';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import ThemeProvider from './theme';

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <ThemeColorPresets>
          <RtlLayout>
            <NotistackProvider>
              <MotionLazyContainer>
                <ProgressBarStyle />
                <ChartStyle />
                <Settings />
                <ScrollToTop />
                <Routes />
              </MotionLazyContainer>
            </NotistackProvider>
          </RtlLayout>
        </ThemeColorPresets>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
